import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

//const API_ROOT = 'http://localhost/api'

export const getCommentation = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/commentation/page?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const saveCommentation = (request, projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/commentation/save?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doPost(url, request)
}
